var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10zm10.709 5.546v-5.44h1.502l.199-1.875h-1.701l.003-.938c0-.49.046-.751.748-.751h.94V4.667h-1.503c-1.804 0-2.44.91-2.44 2.439V8.23H7.334v1.875h1.125v5.44h2.251z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgSocialIconFacebook;